import { getGalleryCategoryUrl } from "@/lib/gallery";
import dynamic from "next/dynamic";

const BeforeAfterGallery = dynamic(() => import("../PatientCarousel"), {
  ssr: false,
});
const OtherPatientsCarousel = dynamic(
  () => import("../OtherPatientsCarousel"),
  { ssr: false }
);
const BreadCrumbs = dynamic(() => import("../BreadCrumbs"), { ssr: false });

interface PatientSectionProps {
  data: {
    procedure: {
      title: string;
      slug: string;
    };
    patient: {
      id: string;
      title: string;
      history: string;
      photos: {
        site_content_collections_id: {
          collection: {
            item: {
              image_file: {
                image: {
                  id: string;
                  filename_download: string;
                };
              };
              alt?: string;
            };
          }[];
        };
      }[];
    };
    patients: {
      id: string;
      title: string;
      photos: {
        site_content_collections_id: {
          collection: {
            item: {
              image_file: {
                image: {
                  id: string;
                  filename_download: string;
                };
              };
              alt?: string;
            };
          }[];
        };
      }[];
    }[];
  };
}

export default function PatientSection({ data }: PatientSectionProps) {
  const { procedure, patient, patients } = data;

  return (
    <>
      <BreadCrumbs
        className="bg-accent-color-three-dark text-[#fff] py-6 px-6 md:py-6 md:px-12 lg:py-8 lg:px-32 m-0 text-span-medium"
        segments={[
          {
            title: procedure.title,
            url: getGalleryCategoryUrl(procedure.slug),
          },
          {
            title: patient.title,
          },
        ]}
      />
      <section
        id="PatientSection"
        className="bg-accent-color-three px-6 py-12 md:px-12 md:py-16 lg:py-16 lg:px-36"
      >
        <div>
          <BeforeAfterGallery
            patient={patient}
            patients={patients}
            procedure={procedure}
          />

          <OtherPatientsCarousel
            patients={patients}
            patient={patient}
            procedureSlug={procedure.slug}
          />
        </div>
      </section>
    </>
  );
}
